/**
 * LinkedIn Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import type { IconProps } from '../../types';

export function LinkedInIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'LinkedIn',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faLinkedin}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
